import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';

const HorseLink = ({
    horseProfileUrl,
    horseName,
    raceNumber,
}) => (
    <span className="nr-block__horseName">
        <a
            className="ui-link ui-link_table js-popupLink"
            href={horseProfileUrl}
        >
            {horseName}
            <Svg
                iconName="right"
                size="XSmall"
            />
        </a>
        {raceNumber &&
            <span className="nr-block__raceNumber">
                {` ${raceNumber}`}
            </span>
        }
    </span>
);

HorseLink.propTypes = {
    horseProfileUrl: PropTypes.string.isRequired,
    horseName: PropTypes.string.isRequired,
    raceNumber: PropTypes.string,
};

export default HorseLink;



// WEBPACK FOOTER //
// ./src/js/nonRunners/components/HorseLink.jsx